import { render, staticRenderFns } from "./ReservationMail.vue?vue&type=template&id=cbe3ca9c&scoped=true&"
import script from "./ReservationMail.vue?vue&type=script&lang=js&"
export * from "./ReservationMail.vue?vue&type=script&lang=js&"
import style0 from "./ReservationMail.vue?vue&type=style&index=0&id=cbe3ca9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe3ca9c",
  null
  
)

export default component.exports